@if (loading) {
<bracelit-preloader
  style="height: 100%; display: flex; justify-content: center; align-items: center;"></bracelit-preloader>
}

<div style="display: flex; flex-direction: row; flex-wrap: wrap;">
  @if (!loading) {
  <div
    style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: center; justify-content: center;  width: 100%;">
    <div style="display: flex !important; display: flex; align-items: center !important; justify-content: right !important;
      height:fit-content !important; width:100% !important;" (click)="onGoBack()">
      <img [src]="'assets/icons/crossClose.svg'" style="cursor: pointer;">
    </div>
    <div style="display: flex !important; display: flex; align-items: center !important; justify-content: center !important;
      height:fit-content !important; width:100% !important; flex-direction: column;">
      <mat-icon svgIcon="transactions-large" class="primary-color" style="width: 49px; height: 49px;"></mat-icon>
      <div class="voucher-title bold-20px-center-marine primary-border-100"
        style="margin-bottom: 20px !important; margin-top: 10px !important;">
        {{ 'payments.history' | translate }}
      </div>
    </div>
    <div class="bracelit-card-content"
      style="display: flex !important; flex-direction:column !important; max-height: calc(60vh - 134px) !important; width: 95% !important; overflow-y:scroll !important">

      @if (creditMoves.length === 0) {
      <div class="transaction-row" style="display: flex; flex-direction: row; flex-wrap: wrap; width: 100%;">
        <div
          style="width: 100%; display: flex; flex-direction: row; display: flex; align-items: center; justify-content: center; color: #0F223E; padding: 5em 25px; font-size: 18px; text-align: center;">
          <span>{{ 'payments.haveNo' | translate }}</span>
        </div>
      </div>
      }

      @for (credit_move of creditMoves; track credit_move.id) {
      <div class="transaction-row" style="width: 100%;">
        <!-- <div class="transaction-icon" style="width: 36px; display: flex; align-items: center; justify-content: center;">
              @if (!credit_move.voucherId) {
                <img [src]="'assets/icons/arrow_pay_' + (credit_move.amount > 0 ? 'up' : 'down') + '.svg'" alt="">
              }

              @if (credit_move.voucherId) {
                <img [src]="'assets/icons/empty_ticket_secondary.svg'" alt="">
              }
            </div> -->
        <div class="transaction-container grey-border-100"
          style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: center; justify-content: center; margin: 10px 0px 0px 0px;">
          <details style="width: 100%;">
            <summary class="transaction-container transparent-border-100"
              style="display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: center; justify-content: center; margin: 10px 0px 0px 0px; width: 100%;">
              <div class="sub-row"
                style="display: flex; align-items: center; justify-content: space-between; width:100%">
                <div class="transaction-title bold-16px-left-marine" style="width: 60%;">
                  {{!credit_move.voucherId ?
                  (credit_move.amount < 0 ? checkAction(credit_move) : rechargeText + coinName) : (credit_move.uses < 0
                    ? payText : rechargeText) + data.voucherLabelMinus}} </div>
                    <div class="transaction-amount bold-16px-right-marine" style="display: flex; align-items: center">
                      <!-- {{!credit_move.voucherId ? (credit_move.amount|number: '1.2-2')
                        : (credit_move.uses|number: '1.2-2')}} -->
                      {{!credit_move.voucherId ? (credit_move.amount | number)
                      : (credit_move.uses)}}
                      @if (!credit_move.voucherId) {
                      <span>€</span>
                      }
                      @if (credit_move.voucherId) {
                      <span style="display:flex; align-items:center">
                        <mat-icon svgIcon="coins" style="width:20px !important" class="marine-color"></mat-icon>
                      </span>
                      }
                    </div>
                </div>
                <div class="sub-row" style="width: 100%; width: 100%;margin: 0px 0px 10px 0px;">
                  <div class="light-12px-left-grey" style="width: 50%;">
                    {{credit_move.created | date : 'dd-MM-yyyy'}} | {{credit_move.created | date : 'HH:mm'}}h
                  </div>
                </div>
            </summary>
            @if (credit_move.paymentMethod !== null && credit_move.paymentMethod !== undefined) {
            <div class="payment-details-date light-14px-center-primary"
              style="display: flex; justify-content: space-between; width: 100% !important; margin-bottom: 10px;">
              <div>
                {{ 'payments.method' | translate}}
              </div>
              <div>
                {{credit_move.paymentMethod}}
              </div>
            </div>
            }

            @if (credit_move.recycling !== null && credit_move.recycling !== undefined) {
            <div class="payment-details-date light-14px-center-primary"
              style="display: flex; justify-content: space-between; width: 100% !important; margin-bottom: 10px;">
              <div>
                {{ 'payments.recycle' | translate}}
              </div>
            </div>
            }

            @if (credit_move.saleOrderLines && credit_move.saleOrderLines.length > 0) {
            <div style="width: 100%;">
              @for (producto of credit_move.saleOrderLines; track producto.id) {
              <div class="payment-details-date light-14px-center-primary"
                style="display: flex; justify-content: space-between; width: 100% !important; margin-bottom: 10px;">
                @if (producto.name !== null && producto.name !== undefined && producto.unitPrice !== null &&
                producto.unitPrice !== undefined && producto.quantity !== null && producto.quantity !== undefined) {
                <div>
                  {{producto.name}} {{producto.unitPrice | number}}€ (x{{producto.quantity | number}})
                </div>
                }
                @if (producto.total !== null && producto.total !== undefined) {
                <div>
                  {{producto.total | number}}€
                </div>
                }
              </div>
              }
            </div>
            }

            @if (credit_move.vbName !== null && credit_move.vbName !== undefined) {
            <div class="payment-details-date light-14px-center-primary"
              style="display: flex; justify-content: space-between; width: 100% !important; margin-bottom: 10px;">
              <div>
                {{credit_move.vbName}}
              </div>
              <div>

              </div>
            </div>
            }
          </details>
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>